import { createSelector, createSlice } from '@reduxjs/toolkit'
import { itemKey } from 'components/QuestionnaireRequest/Property/Tabs/Pricing/utilities'

const initialState = {
  initialized: false,
  tabs: [
    {
      tab: 'general',
      label: 'general',
    },
    {
      tab: 'pricing',
      label: 'pricing',
    },
    {
      tab: 'processors',
      label: 'processors',
    },
  ],
  questionnairePrices: [],
  enabled: false,
  questionnaireType: null,
  overrideGenericForm: false,
  genericFormId: null,
  limitAcceptedFormTypes: false,
  questionnaireAcceptedFormTypes: [],
  organizationQuestionnaireType: null,
  adminEmails: [],
}

const buildingQuestionnaireAdminSlice = createSlice({
  name: 'buildingQuestionnaireAdmin',
  initialState,
  reducers: {
    setInitialState: (state, action) => {
      return { ...state, ...action.payload, initialized: true }
    },
    addNewPrice: (state, action) => {
      const newPrice = action.payload
      state.questionnairePrices.push(newPrice)
    },
    updatePrice: (state, action) => {
      const { oldKey, updatedPrice } = action.payload
      const itemIndex = state.questionnairePrices.findIndex((price) => itemKey(price) === oldKey)
      if (itemIndex !== -1) {
        state.questionnairePrices[itemIndex] = updatedPrice
      }
    },
    removePrice: (state, action) => {
      const priceKey = action.payload
      const itemIndex = state.questionnairePrices.findIndex((price) => itemKey(price) === priceKey)
      if (itemIndex !== -1) {
        state.questionnairePrices.splice(itemIndex, 1)
      }
    },
    setEnabled: (state, action) => {
      state.enabled = action.payload
    },
    setQuestionnaireType: (state, action) => {
      state.questionnaireType = action.payload
    },
    setOverrideGenericForm: (state, action) => {
      state.overrideGenericForm = action.payload
    },
    setGenericFormId: (state, action) => {
      state.genericFormId = action.payload
    },
    setLimitAcceptedFormTypes: (state, action) => {
      state.limitAcceptedFormTypes = action.payload
    },
    setQuestionnaireAcceptedFormTypes: (state, action) => {
      state.questionnaireAcceptedFormTypes = action.payload
    },
    setOrganizationQuestionnaireType: (state, action) => {
      state.organizationQuestionnaireType = action.payload
    },
    setAdminEmails: (state, action) => {
      state.adminEmails = action.payload
    },
  },
})

export const {
  setInitialState,
  addNewPrice,
  updatePrice,
  removePrice,
  setEnabled,
  setQuestionnaireType,
  setOverrideGenericForm,
  setGenericFormId,
  setLimitAcceptedFormTypes,
  setQuestionnaireAcceptedFormTypes,
  setOrganizationQuestionnaireType,
  setAdminEmails,
} = buildingQuestionnaireAdminSlice.actions

const selectBuildingQuestionnaireAdmin = (state) => state.buildingQuestionnaireAdmin

const selectPrices = createSelector(selectBuildingQuestionnaireAdmin, (state) => state.questionnairePrices)
export const selectActivePrices = createSelector(selectPrices, (prices) => prices.filter((price) => !price.disabled))
export const selectInActivePrices = createSelector(selectPrices, (prices) => prices.filter((price) => price.disabled))
export default buildingQuestionnaireAdminSlice.reducer
